var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import keycode from 'keycode';

var scrollKeys = [keycode('left'), keycode('right'), keycode('up'), keycode('down'), keycode('space'), keycode('pgup'), keycode('pgdn'), keycode('end'), keycode('home')].reduce(function (scrollKeys, key) {
  scrollKeys[key] = true;
  return scrollKeys;
}, {});

export var preventDefault = function preventDefault(e) {
  e.preventDefault();
  e.returnValue = false;
};

/**
 * Modal component
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.handleScrollAndEscKeys = function (e) {
      if (scrollKeys[e.keyCode]) {
        preventDefault(e);
        return false;
      } else if (e.keyCode === keycode('esc')) {
        _this.props.toggle(false);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'disableScroll',
    value: function disableScroll() {
      window.addEventListener('DOMMouseScroll', preventDefault, false);
      window.addEventListener('wheel', preventDefault, false);
      window.addEventListener('touchmove', preventDefault, false);
      window.addEventListener('keydown', this.handleScrollAndEscKeys, false);
    }
  }, {
    key: 'enableScroll',
    value: function enableScroll() {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
      window.removeEventListener('wheel', preventDefault, false);
      window.removeEventListener('touchmove', preventDefault, false);
      window.removeEventListener('keydown', this.handleScrollAndEscKeys, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.visible && !this.props.visible) {
        document.activeElement.blur();
        this.disableScroll();
      } else if (!props.visible && this.props.visible) {
        this.enableScroll();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          header = _props.header,
          body = _props.body,
          footer = _props.footer,
          visible = _props.visible,
          toggle = _props.toggle;

      return React.createElement(
        'div',
        {
          className: classNames('mdc-Modal-overlay', { 'is-visible': visible }),
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            toggle(false);
          }
        },
        React.createElement(
          'div',
          {
            className: classNames('mdc-Modal', { 'is-visible': visible }),
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            onTouchEnd: function onTouchEnd(e) {
              return e.stopPropagation();
            }
          },
          React.createElement(
            'div',
            { className: 'mdc-Modal-content' },
            React.createElement(
              'div',
              { className: 'mdc-Modal-header' },
              header
            ),
            React.createElement(
              'div',
              { className: 'mdc-Modal-body' },
              body
            )
          ),
          React.createElement(
            'div',
            { className: 'mdc-Modal-footer' },
            footer
          )
        )
      );
    }
  }]);

  return Modal;
}(React.Component);

Modal.propTypes = {
  header: PropTypes.element,
  body: PropTypes.element,
  footer: PropTypes.element,
  visible: PropTypes.bool,
  toggle: PropTypes.func
};

Modal.defaultProps = {
  visible: false,
  toggle: function toggle() {}
};

export default Modal;


//////////////////
// WEBPACK FOOTER
// ../es/js/modal/index.js
// module id = 289
// module chunks = 0